import { render, staticRenderFns } from "./BoardingsPrint.vue?vue&type=template&id=1fba2cc8&scoped=true&"
import script from "./BoardingsPrint.vue?vue&type=script&lang=js&"
export * from "./BoardingsPrint.vue?vue&type=script&lang=js&"
import style0 from "./BoardingsPrint.vue?vue&type=style&index=0&id=1fba2cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba2cc8",
  null
  
)

export default component.exports